import { AppRoutes } from './AppRoutes';

const materialityConfig = [
  {
    id: 1,
    url: AppRoutes.materialityAssessmentInvestorsCustomersEvidence,
  },
  {
    id: 2,
    url: AppRoutes.materialityAssessmentNonRegulatory,
  },
  {
    id: 3,
    url: AppRoutes.materialityAssessmentCompetitor,
  },
  {
    id: 4,
    url: AppRoutes.materialityAssessmentAnalysis,
  },
  {
    id: 5,
    url: AppRoutes.materialityAssessmentGeographic,
  },
  {
    id: 6,
    url: AppRoutes.materialityAssessmentIndustry,
  },
];

export default materialityConfig;
